// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s5-6";
export var imgContainer = "_s5-3";
export var menuIcon = "_s5-5";
export var pillWrapper = "_s5-2";
export var pillsContainer = "_s5-1";
export var subscriptionCard = "_s5-0";
export var subscriptionLogo = "_s5-4";